module.exports = __webpack_public_path__ + "static/img/034_TO8_1495_og.e209079.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/wedding/034_TO8_1495_og.jpg
// module id = EVu7
// module chunks = 0